import { SkeletonElement } from '../loading/SkeletonElement/SkeletonElement';
import {
  containerStyles,
  titleSectionStyles,
  titleStyles,
} from './CarouselCard';

export const CarouselCardSkeleton = () => (
  <div className={containerStyles}>
    <div className={titleSectionStyles}>
      <div className={titleStyles}>
        <SkeletonElement height="30px" width="100px" />
      </div>
      <SkeletonElement height="30px" width="30px" />
    </div>

    <SkeletonElement height="20px" width="150px" />
  </div>
);
